define('gameday-index-gdads/subcomponents/GDIndexAdUnit',['require','exports','module','jquery','message-service/message-service','gameday-index-enums/enums/events/SponsorshipEvents','./AdvertisingUtils','extant/extant'],function(require, module, exports){
	var $ = require("jquery"),
		dispatcher = require("message-service/message-service"),
		AdEvents = require("gameday-index-enums/enums/events/SponsorshipEvents"),
		AdUtils = require("./AdvertisingUtils"),
		exists = require("extant/extant");

	var roadblockDisplayed = false;

	function GDIndexAdUnit(adDef) {
		this.unitID = adDef.ID;
		this.container = adDef.container;
		this.width = parseInt(adDef.width);
		this.height = parseInt(adDef.height);
		this.className = adDef.cssClass || "";

		this.modalAd = adDef.modal || false;

		// set the appropriate listener
		if (this.iframe) { 
			dispatcher.addListener.call(this, AdEvents.refreshPageAds, this.loadAd); 
		} else if (!this.modal) {
			dispatcher.addListener.call(this, AdEvents.refreshAdImage, this.updateAdImage); 
		} else {
			dispatch.addListener.call(this, AdEvents.displayInsterstitalRoadblock, this.displayRoadblockAd);
		}
		this.init();
	}

	GDIndexAdUnit.prototype = ({
		handleAdUpdates: function(payload, evt) {
			if (exists(payload, this.unitID)) {
				var paylaod = payload[this.unitID];
			}
		},

		init: function() {
			var div = document.getElementById(this.unitID);
			if (!exists(div)) {
				div = document.createElement("div");
				div.className = this.className;
				div.id = this.unitID;
				$(div).appendTo(this.targetDiv);
			} else if (this.modalAd !== true) {
				$(div).addClass(this.className);
			}

			if (this.iframe) {
				this.loadAd();
			} else if (this.modalAd) {
				this.displayRoadblockAd();
			}
		},

		buildAdRequest: function() {
			var keys = AdUtils.getKeyVals();
			return [ 'http://ad.doubleclick.net/adi/',
					 this.site, '/', this.section,
					 ';pos=', this.tile,
					 ';sz=', this.width,
					 'x', this.height,
					 ';tile=', this.tile,
					 (keys) ? ";" + keys : '',
					 ';', keys,
					 ';ord=', new Date().valueOf() ].join("");
		},

		loadAd: function(payload, evt) {
			var div,
				req = this.buildAdRequest();

			div = document.createElement("iframe");
			$(div).width(this.width);
			$(div).height(this.height);
			$(div).attr({
				"src": req,
				"marginwidth": "0",
				"marginheight": "0",
				"frameborder": "0",
				"scrolling": "no",
				"id": "gdAd_" + this.tile
			});

			var container = document.getElementById(this.unitID);
			$(container).empty();
			$(div).appendTo(container);
		},

		updateAdImage: function(payload, evt) {
			//console.info(payload.targetID + " -- " + this.unitID);
			if (payload.targetID !== this.unitID) {
				return;
			}


			var bgColor = payload.bgColor || '#000',
				img = (payload.img) ? payload.img : 'none',
				bgRepeat = payload.bgRepeat || 'no-repeat',
				bgAttachment = payload.bgAttachment || 'scroll',
				bgPosotion = payload.bgPosition || ((this.unitID == "leftRailAdTag") ? "100% 0%" : "0"),
				clickHref = payload.clickHref || null,
				clickTarget = payload.clickTarget || '_blank',
				clickHeight = payload.clickHeight || '900px',
				clickTop = payload.clickTop || '0'

			$('#' + this.unitID).css({
				"background-color": bgColor,
				"background": img,
				"background-repeat": bgRepeat,
				'background-attachment': bgAttachment,
				'background-position': bgPosotion,
				'height': clickHeight,
				'top': clickTop
			}).attr({
				'target': clickTarget,
				'href': clickHref
			});
		},

		displayRoadblockAd: function() {
			if (roadblockDisplayed) { return; }
			roadblockDisplayed = true;
			var self = this,
				ad_url,
				dc_site = "mlb.mlb",// TODO gimme params, dude, like language es.mlb.mlb etc
				ran_number = Math.round( Math.random()*1000000000 );

			var adPixel = document.createElement("div");
			$(adPixel).css({
				"width": "1px",
				"height": "1px",
				"overflow": "hidden"
			});

			$(adPixel).attr("id", self.targetDiv.substr(1));
			$(adPixel).appendTo("body");

			var roadblockAdFrame = document.createElement('iframe');

			ad_url = "http://ad.doubleclick.net/N2605/adj/mlb.mlb/gameday;" + AdUtils.getKeyVals() + ";branding=true;dcopt=ist;page=gameday;pos=1;sz=1x1;tile=2;ord=" + ran_number + "?";
			ad_url = escape(ad_url);

			roadblockAdFrame.async = true;
			roadblockAdFrame.src = "/sections/gameday/adFrame.html" + "#adURL=" + ad_url;

			setTimeout(function() {
				$(roadblockAdFrame).appendTo(self.targetDiv); }, 3000
			);
		}
	});

	return GDIndexAdUnit;
});

